import { atom } from 'recoil';
import { IResultadoRealizacaoCompetencia } from '../../commons/types/crm';


export const perfilCompetenciasAtom = atom<IResultadoRealizacaoCompetencia[]>({
  key: 'resultadoRealizacaoCompetencias', 
  default: [] as IResultadoRealizacaoCompetencia[],
}); 
